export const GRANTS = {
  PORTAL_USER: 'portal_user',
  RESPONDER: 'responder',
  INSTALLER: 'installer',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
  ASSOCIATE: 'associate',
  DISPATCHER: 'dispatcher',
}
